import { getScreenData, Store } from 'cw-ui-core';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import every from 'lodash/every';

export const getConnectedAppsData = screenKey => {
    const connectedAppsInfoList = [];

    const connectedAppsState = getScreenData(Store().getState().screen, ['roleDetails', 'connectedApps'], screenKey);
    const assignedIdentityRoles = getScreenData(
        Store().getState().screen,
        ['assignedRoles', 'selectedRoles'],
        screenKey
    );
    const connectedAppsMap = connectedAppsState ? connectedAppsState.toJS() : {};
    const assignedIdentityRolesMap = assignedIdentityRoles ? assignedIdentityRoles.toJS() : {};

    const connectedAppsIds = Object.keys(connectedAppsMap);
    if (connectedAppsIds && !isEmpty(connectedAppsIds)) {
        forEach(connectedAppsIds, appId => {
            const connecteAppInfo = {
                connectedAppId: appId,
                hasAssignedIdentityRoles: !isEmpty(assignedIdentityRolesMap),
            };
            const rolesInfo = connectedAppsMap[appId].rolesWithResources;
            const applicationRoles = [];

            const currentSelection = getScreenData(
                Store().getState().screen,
                ['roleDetails', 'connectedApps', `${appId}`, 'selectedRoles'],
                screenKey
            );
            const selectedRoles = currentSelection && currentSelection.toJS();

            const rolesIds = rolesInfo ? Object.keys(rolesInfo) : [];
            forEach(rolesIds, roleId => {
                if (selectedRoles && Object.values(selectedRoles).includes(roleId)) {
                    const appRole = {
                        roleId,
                    };

                    const roleResources = rolesInfo[roleId];
                    const assignedResources =
                        roleResources && roleResources.selectedResources && roleResources.selectedResources.length > 0
                            ? map(roleResources.selectedResources, ({ id, name, type }) => ({
                                  resourceId: id,
                                  resourceType: type,
                                  resourceDisplayName: name,
                              }))
                            : [];

                    appRole.assignedResources = assignedResources;
                    appRole.isResourcesEnabled = !!roleResources.isResourcesEnabled;
                    appRole.isResourcesRequired = !!roleResources.isResourcesRequired;
                    applicationRoles.push(appRole);
                }
            });

            if (applicationRoles.length > 0) {
                connecteAppInfo.applicationRoles = applicationRoles;
            }

            connectedAppsInfoList.push(connecteAppInfo);
        });
    }

    return connectedAppsInfoList;
};

export const isConnectedAppsValid = connectedApps => {
    if (!connectedApps || connectedApps.length <= 0) {
        return true;
    }
    return every(connectedApps, ({ applicationRoles }) => {
        if (applicationRoles && !isEmpty(applicationRoles)) {
            return every(
                applicationRoles,
                ({ assignedResources, isResourcesEnabled }) => !isResourcesEnabled || assignedResources
            );
        }
        return true;
    });
};

export const getAppDisplayName = app => {
    const appBaseName = app?.applicationBaseName;
    const appFriendlyName = app?.instanceFriendlyName;
    const appProductName = app?.productName;
    const appId = app?.connectedAppId;

    return `${appBaseName || appFriendlyName || appProductName || appId}`;
};

export const hasDataFilledProperly = connectedAppsValidity => {
    let isValid = true;
    if (!isEmpty(connectedAppsValidity)) {
        const keys = Object.keys(connectedAppsValidity);
        forEach(keys, key => {
            isValid = isValid && connectedAppsValidity[key];
        });
    }
    return isValid;
};
